import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="w-full bg-[#f5f5f5] py-16 md:py-20 lg:py-24 px-4" data-id="element-237">
      <div className="max-w-7xl mx-auto" data-id="element-238">
        <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-gray-900 text-center mb-8" data-id="element-239">
          Barberos que ya aplican{' '}
          <span className="text-[#c41e3a]" data-id="element-240">el método</span>
        </h2>
        <div className="w-32 h-1 bg-[#c41e3a] mx-auto mb-20" data-id="element-241"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16" data-id="element-242">
          {/* Testimonial 1 */}
          <div className="bg-white rounded-lg p-12 shadow-lg border-4 border-gray-300" data-id="element-243">
            <QuoteIcon className="w-16 h-16 text-[#c41e3a] mb-8" aria-hidden="true" data-id="element-244" />
            <p className="text-gray-700 text-2xl leading-relaxed mb-8" data-id="element-245">
              "Ahora entiendo por qué hago cada corte. Uso el ebook como guía
              todos los días."
            </p>
            <p className="text-gray-900 font-black text-xl" data-id="element-246">
              Lucas M. – Buenos Aires
            </p>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-white rounded-lg p-12 shadow-lg border-4 border-gray-300" data-id="element-247">
            <QuoteIcon className="w-16 h-16 text-[#c41e3a] mb-8" aria-hidden="true" data-id="element-248" />
            <p className="text-gray-700 text-2xl leading-relaxed mb-8" data-id="element-249">
              "Dejé de improvisar. El método te ordena la cabeza y el trabajo."
            </p>
            <p className="text-gray-900 font-black text-xl" data-id="element-250">
              Matías R. – Córdoba Capital
            </p>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-white rounded-lg p-12 shadow-lg border-4 border-gray-300" data-id="element-251">
            <QuoteIcon className="w-16 h-16 text-[#c41e3a] mb-8" aria-hidden="true" data-id="element-252" />
            <p className="text-gray-700 text-2xl leading-relaxed mb-8" data-id="element-253">
              "No es un curso más. Es una formación bien pensada."
            </p>
            <p className="text-gray-900 font-black text-xl" data-id="element-254">
              Nicolás G. – Rosario
            </p>
          </div>

          {/* Testimonial 4 */}
          <div className="bg-white rounded-lg p-12 shadow-lg border-4 border-gray-300" data-id="element-255">
            <QuoteIcon className="w-16 h-16 text-[#c41e3a] mb-8" aria-hidden="true" data-id="element-256" />
            <p className="text-gray-700 text-2xl leading-relaxed mb-8" data-id="element-257">
              "Me ayudó a profesionalizarme y a cobrar mejor mis servicios."
            </p>
            <p className="text-gray-900 font-black text-xl" data-id="element-258">
              Franco D. – La Plata
            </p>
          </div>
        </div>
      </div>
    </section>;
}